var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"app",attrs:{"id":"app"}},[_c('a-spin',{attrs:{"spinning":_vm.spinning,"tip":_vm.tip}},[_c('router-view',{on:{"changeSpining":_vm.changeSpining}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }